var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileCode = function SvgIconFileCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.832 13.082a1 1 0 0 0-1.414-1.414l-2.25 2.25a1 1 0 0 0 0 1.414l2.25 2.25a1 1 0 0 0 1.414-1.414L9.29 14.625zM16.832 13.918l-2.25-2.25a1 1 0 0 0-1.414 1.414l1.543 1.543-1.543 1.543a1 1 0 0 0 1.414 1.414l2.25-2.25a1 1 0 0 0 0-1.414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 2A1.75 1.75 0 0 0 3.5 3.75v16.5A1.75 1.75 0 0 0 5.25 22h13.5a1.75 1.75 0 0 0 1.75-1.75v-12a1 1 0 0 0-.293-.707l-5.25-5.25A1 1 0 0 0 14.25 2zm.25 2v16h13V9.625h-4.625a1 1 0 0 1-1-1V4zm9.375 1.04v2.585h2.586z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFileCode;